/* eslint-disable */
export default {
  close: 'Fermer',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
